import { methodNotFoundError } from './JsonRpcError';
import { jsonRpcFailure } from './JsonRpcRequest';
import type { JsonRpcRequest, JsonRpcResult } from './JsonRpcRequest';

// 接続中のビューモデル全体を画像として取得するリクエスト。
// ワイヤ仕様上 params は空オブジェクト（id 付きリクエストでは params 必須のため {} を受ける）。
// 検証すべきフィールドはなく、前方互換のため余剰フィールドは無視する。
export class GetViewModelImageRequest {
  static readonly METHOD = 'get_view_model_image';

  private constructor(private readonly _requestId: string) {}

  get requestId(): string {
    return this._requestId;
  }

  static from(req: JsonRpcRequest): JsonRpcResult<GetViewModelImageRequest> {
    if (req.method !== GetViewModelImageRequest.METHOD) {
      return jsonRpcFailure(req.id, methodNotFoundError('unknown_method', `unknown method: ${req.method}`));
    }

    return { ok: true, value: new GetViewModelImageRequest(req.id) };
  }
}
